import React, { useState } from 'react';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import { useDataUser } from '../../context/dataUserContext';
import Contenedor from '../GlobalComponents/Contenedor';
import { ReactComponent as RIPSIcon } from '../../assets/icons/RIPS.svg';

const RipsReport = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [rips, setRips] = useState([]);
  const [loading, setLoading] = useState(false);
  const { clinicId } = useDataUser();

  // Obtener los RIPS filtrados por fecha
  const fetchRips = async () => {
    try {
      if (!startDate || !endDate) {
        alertaGeneral({
          titulo: "Fechas requeridas",
          messageHtml: "Por favor, selecciona ambas fechas.",
          isWarning: true,
        });
        return;
      }
      setLoading(true);
      const response = await apiClient.get(`/api/clinic/getRipsByDate`, {
          params: { startDate, endDate, clinicId }
      });
      setRips(response.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      alertaGeneral({
        titulo: "Error",
        messageHtml: "Ocurrió un error al obtener los RIPS.",
        isError: true
      });
    }
  };

  // Descargar todos los RIPS filtrados como JSON
  const descargarTodos = () => {
    if (!rips.length) return;
    const blob = new Blob([JSON.stringify(rips, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `RIPS_${startDate}_to_${endDate}.json`;
    link.click();
    URL.revokeObjectURL(url);
  };

  // Descargar un RIP individual como JSON
  const descargarIndividual = (rip, idx) => {
    const blob = new Blob([JSON.stringify(rip, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `RIP_${rip.numDocumentoIdObligado || idx}.json`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Contenedor icon={RIPSIcon} title="RIPS">
      <p className="form-label text-left">
        Selecciona un rango de fechas para visualizar y descargar los RIPS.
      </p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 mx-15 mx-auto">
        <div className="col-span-1">
          <label className="form-label">Fecha Inicio</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="form-input"
          />
        </div>
        <div className="col-span-1">
          <label className="form-label">Fecha Fin</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="form-input"
          />
        </div>
      </div>
      <div className="mt-4 flex gap-2">
        <button onClick={fetchRips} className="button-send">Buscar</button>
        <button onClick={descargarTodos} className="button-send" disabled={!rips.length}>Descargar todos</button>
      </div>
      <div className="mt-8">
        {loading && <p>Cargando RIPS...</p>}
        {!loading && rips.length > 0 && (
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border text-xs">
              <thead>
                <tr>
                  <th className="border px-2 py-1">#</th>
                  <th className="border px-2 py-1">Num. Doc. Id Obligado</th>
                  <th className="border px-2 py-1">Num. Factura</th>
                  <th className="border px-2 py-1">Tipo Nota</th>
                  <th className="border px-2 py-1">Num. Nota</th>
                  <th className="border px-2 py-1">Tipo Doc. Usuario</th>
                  <th className="border px-2 py-1">Num. Doc. Usuario</th>
                  <th className="border px-2 py-1">Tipo Usuario</th>
                  <th className="border px-2 py-1">Fecha Nacimiento</th>
                  <th className="border px-2 py-1">Sexo</th>
                  <th className="border px-2 py-1">Zona Residencia</th>
                  <th className="border px-2 py-1">Fecha Atención</th>
                  <th className="border px-2 py-1">Cod. Consulta</th>
                  <th className="border px-2 py-1">Diagnóstico Principal</th>
                  <th className="border px-2 py-1">Valor Servicio</th>
                  <th className="border px-2 py-1">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rips.map((rip, idx) => {
                  const usuario = rip.usuarios?.[0] || {};
                  const consulta = usuario.servicios?.consultas?.[0] || {};
                  return (
                    <tr key={idx}>
                      <td className="border px-2 py-1">{idx + 1}</td>
                      <td className="border px-2 py-1">{rip.numDocumentoIdObligado || '-'}</td>
                      <td className="border px-2 py-1">{rip.numFactura || '-'}</td>
                      <td className="border px-2 py-1">{rip.tipoNota || '-'}</td>
                      <td className="border px-2 py-1">{rip.numNota || '-'}</td>
                      <td className="border px-2 py-1">{usuario.tipoDocumentoIdentificacion || '-'}</td>
                      <td className="border px-2 py-1">{usuario.numDocumentoIdentificacion || '-'}</td>
                      <td className="border px-2 py-1">{usuario.tipoUsuario || '-'}</td>
                      <td className="border px-2 py-1">{usuario.fechaNacimiento || '-'}</td>
                      <td className="border px-2 py-1">{usuario.codSexo || '-'}</td>
                      <td className="border px-2 py-1">{usuario.codZonaTerritorialResidencia || '-'}</td>
                      <td className="border px-2 py-1">{consulta.fechaInicioAtencion || '-'}</td>
                      <td className="border px-2 py-1">{consulta.codConsulta || '-'}</td>
                      <td className="border px-2 py-1">{consulta.codDiagnosticoPrincipal || '-'}</td>
                      <td className="border px-2 py-1">{consulta.vrServicio ?? '-'}</td>
                      <td className="border px-2 py-1">
        <button
                          className="text-blue-600 underline"
                          onClick={() => descargarIndividual(rip, idx)}
        >
                          Descargar
        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {!loading && rips.length === 0 && (
          <p className="text-center mt-4">No hay RIPS para el rango seleccionado.</p>
        )}
      </div>
    </Contenedor>
  );
};

export default RipsReport;
